import { render, staticRenderFns } from "./GroupsMetricsTable.vue?vue&type=template&id=a9c24346&scoped=true"
import script from "./GroupsMetricsTable.vue?vue&type=script&lang=js"
export * from "./GroupsMetricsTable.vue?vue&type=script&lang=js"
import style0 from "./GroupsMetricsTable.vue?vue&type=style&index=0&id=a9c24346&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9c24346",
  null
  
)

export default component.exports